












import {Component, Vue} from 'vue-property-decorator';
import {IContentSection} from '@/components/types';
import ContentSection from '@/components/ContentSection.vue';

@Component({
	components: {
		'v-content-section': ContentSection,
	}
})
export default class Download extends Vue {

	get content(): IContentSection {
		return {
			headline: this.$t('download.headline') as string,
			perex: this.$t('download.perex') as string
		}
	}

}
